import type { EStatus } from '@common/types';
import type { MessageInstance } from 'antd/es/message/interface';
import type { HookAPI } from 'antd/es/modal/useModal';
import type { NotificationInstance } from 'antd/es/notification/interface';

export type TMessageConfig = {
  notificationApi: NotificationInstance;
  modalApi?: HookAPI;
  messageApi: MessageInstance;
};

export const TNotificationConfig = {
  showProgress: true,
  pauseOnHover: true,
  duration: 5,
};

export type TDeleteWarning = {
  translateKey: Required<string>;
  status: EStatus;
  styles?: unknown;
  title?: string;
  content?: string;
  onApprove?: () => void;
  config: Partial<TMessageConfig>;
};
